
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.256 24.003a.753.753 0 01-.599-.3l-3.85-5.132a2.29 2.29 0 01-.075-2.636 2.284 2.284 0 013.267-.562l.502.377V7.506a2.252 2.252 0 014.505 0v5.398l3.586.798a3.759 3.759 0 012.922 4l-.511 5.622a.746.746 0 01-.747.682l-9-.003zm8.315-1.497l.449-4.94a2.254 2.254 0 00-1.753-2.4l-4.174-.928a.745.745 0 01-.587-.732v-6a.753.753 0 00-1.505 0v9.747a.746.746 0 01-.75.75.756.756 0 01-.451-.15l-1.7-1.278-.035-.025a.781.781 0 00-1.059 1.121l3.625 4.832 7.94.003z"}}),_c('path',{attrs:{"d":"M6.506 14.356a.745.745 0 01-.526-.215c-3.246-3.186-3.295-8.42-.109-11.667A8.188 8.188 0 0111.76.007c2.177 0 4.229.837 5.778 2.358a8.248 8.248 0 011.364 10.016.754.754 0 01-1.024.274.751.751 0 01-.274-1.025 6.75 6.75 0 00-1.116-8.195 6.711 6.711 0 00-4.727-1.929 6.698 6.698 0 00-4.818 2.019 6.758 6.758 0 00.09 9.546.75.75 0 01-.527 1.285z"}})])
          )
        }
      }
    